import { InputHTMLAttributes, useId } from 'react'
import './Input.css'

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label: string
  name: string
  type?: 'text' | 'email' | 'tel' | 'password'
  maxLength?: number
  required?: boolean
  error?: string
  value?: string
  onChange?: (value: string) => void
}

function Input({
  label,
  name,
  type = 'text',
  maxLength,
  required = false,
  error,
  value,
  onChange,
  className = '',
  ...rest
}: InputProps) {
  const inputId = useId()
  const errorId = `${inputId}-error`
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.value)
    }
  }
  
  const inputClasses = [
    'input-field',
    error ? 'input-field-error' : '',
    className,
  ].filter(Boolean).join(' ')
  
  return (
    <div className="input-container">
      <label htmlFor={inputId} className="input-label">
        {label}
        {required && <span className="input-required" aria-hidden="true">*</span>}
      </label>
      <input
        id={inputId}
        name={name}
        type={type}
        maxLength={maxLength}
        required={required}
        value={value}
        onChange={handleChange}
        className={inputClasses}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error ? errorId : undefined}
        {...rest}
      />
      {error && (
        <span id={errorId} className="input-error" role="alert">
          {error}
        </span>
      )}
    </div>
  )
}

export default Input